import script from "./ProfileSocial.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSocial.vue?vue&type=script&setup=true&lang=js"

import "./ProfileSocial.vue?vue&type=style&index=0&id=21cf6364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21cf6364"]])

export default __exports__